import { ALERT_THRESHOLD_DAYS } from '../../utils/constants';

export default function AgingBadge({ days }) {
  const isAlert = days >= ALERT_THRESHOLD_DAYS;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${
        isAlert ? 'font-bold' : ''
      }`}
      style={{
        background: isAlert ? '#FEE2E2' : '#F9FAFB',
        color: isAlert ? '#991B1B' : '#6B7280',
        borderColor: isAlert ? '#FECACA' : '#E5E7EB',
        animation: isAlert ? 'pulse-slow 2s infinite' : 'none',
      }}
    >
      {isAlert && <span className="text-[10px]">&#9888;</span>}
      {days}d
    </span>
  );
}
